import cn from 'classnames';
import React from 'react';
import { Route } from 'react-router-dom';

import {
  MobileHotelSummary,
  MobileTourSummary,
} from 'checkout/components/Summary';
import OrderLoader from 'src/components/OrderLoader';
import Payment3dsPopup from 'src/components/Payment3dsPopup';

import PaylatePopup from 'src/routes/Checkout/components/PaylatePopup';
import type { CheckoutSteps } from 'src/store/analytics/types';
import PaymentHidden3dsPopup from 'src/components/PaymentHidden3dsPopup';
import Pay2MePopup from 'src/components/Pay2MePopup';
import LazyFlightFail from 'src/routes/Checkout/components/FlightFail/LazyFlightFail';
import AboutRoomPopup from '../../../../components/AboutRoom/AboutRoomPopup';
import ErrorPopup from '../../../../components/ErrorPopup';
import MobileHeader from '../../../../components/MobileHeader/MobileHeader';
import OrderSuccess from '../../../../components/OrderSuccess';
import Sidebar from '../../../../components/Sidebar';
import SimilarPackagesContainer from '../../../../components/SimilarPackages/SimilarPackagesContainer';
import TransitionSwitch from '../../../../components/TransitionSwitch';
import FlightsLuggageTooltip from '../../components/Flights/Luggage/FlightsLuggageTooltip';
import Hotel from '../../components/Hotel';
import Header from '../Header';
import ReactHint from '../Hint/HintFactory';

import {
  BASE_CLASSNAME,
  ROUTE_TRANSITION_TIME,
  TOURISTS_PATH,
} from '../../../../store/constants';
import {
  CHECKOUT_CONTAINER,
  CHECKOUT_CONTAINER_MOBILE,
  MOBILE_CHECKOUT,
} from '../../../../store/constants/classNames';
import { getCheckoutStep, routesList } from './utils';

import MobileHeaderTitle from '../../../../components/MobileHeader/MobileHeaderTitle';
import { getFullPath, getStepPath } from '../../../../utils/globalUtils';
import ArchivePackageBanner from '../../components/Package/ArchivePackageBanner';
import type { CheckoutStep } from './types';

type Props = {
  path: string;
  showLoader: boolean;
  isFinished: boolean;
  routeTransitionStart: () => void;
  routeTransitionEnd: () => void;
  isMobile: boolean;
  isFuture: boolean;
  isHotelOnly: boolean;
  hasAdjustParams: boolean;
  archivedAt: string | null;
  sendPageview: (value: CheckoutSteps) => void;
};

const Layout = (props: Props) => {
  const {
    path,
    showLoader,
    isFinished,
    routeTransitionStart,
    routeTransitionEnd,
    isMobile,
    hasAdjustParams,
    archivedAt,
    isFuture,
    isHotelOnly,
    sendPageview,
  } = props;

  const routesWithActualPath = routesList.map((item) => ({
    ...item,
    path: getFullPath(item.path),
  }));

  const onTransitionEnd = () => {
    routeTransitionEnd();
    /**
     * Подменяется название компонента на flights для аналитики,
     * если пользователь переходит на первый шаг чекаута
     */
    const step = getCheckoutStep(path) as CheckoutStep | undefined;
    if (!step) return;
    sendPageview(`package_checkout_${step}`);
  };

  const isArchived = archivedAt && !isFuture;

  return (
    <div className={cn({ [MOBILE_CHECKOUT]: isMobile })}>
      <ReactHint autoPosition events attribute="data-text-hint" />

      {/* хинт может отображаться и в сайдбаре и в перелётах */}
      <ReactHint
        autoPosition
        attribute="data-luggage"
        className="react-hint"
        events
        onRenderContent={(target, content) =>
          content && (
            <div className={!isMobile ? 'react-hint__content' : ''}>
              <FlightsLuggageTooltip luggage={JSON.parse(content)} hasTitle />
            </div>
          )
        }
      />
      <ErrorPopup />
      <Payment3dsPopup />
      <PaymentHidden3dsPopup />
      <Pay2MePopup />
      <PaylatePopup />
      <AboutRoomPopup />
      {isHotelOnly ? <MobileHotelSummary /> : <MobileTourSummary />}

      <div
        className={cn(CHECKOUT_CONTAINER, {
          [CHECKOUT_CONTAINER_MOBILE]: isMobile,
        })}
      >
        {!isFinished && (
          <>
            {isArchived && <ArchivePackageBanner />}
            {!isArchived && (isMobile ? <MobileHeader /> : <Header />)}
            {isMobile && getStepPath(path) !== TOURISTS_PATH && (
              <MobileHeaderTitle />
            )}
            <Route path="/:id" exact component={Hotel} />
          </>
        )}

        {!isArchived && !hasAdjustParams && (
          <div className={`${BASE_CLASSNAME}__main`}>
            {!isMobile && (
              <aside>
                <Sidebar />
              </aside>
            )}
            <section>
              {isFinished ? (
                <OrderSuccess />
              ) : (
                <TransitionSwitch
                  currentPath={path}
                  routes={routesWithActualPath}
                  transitionTime={ROUTE_TRANSITION_TIME}
                  onTransitionStart={routeTransitionStart}
                  onTransitionEnd={onTransitionEnd}
                />
              )}
            </section>
          </div>
        )}
      </div>

      <LazyFlightFail />
      {!isArchived && <SimilarPackagesContainer />}
      {showLoader && <OrderLoader />}
    </div>
  );
};

export default Layout;
